import * as React from 'react'
import { cn } from '@/lib/utils'
import { IconArrowRight, IconArrowLeft } from '@tabler/icons-react'


export interface ArrowButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	text: string
	direction?: 'right' | 'left' | 'up' | 'down'
	fullWidth?: boolean
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({
	text,
	className,
	direction,
	fullWidth,
	type = 'button',
	...rest
}) => {
	return (
		<button
			type={type}
			className={cn(
				'box-border inline-flex items-center justify-center gap-1 rounded-lg bg-white px-3 py-2 h-9 w-[103px] text-sm font-medium border border-[#EAECF0] shadow-[0px_1px_2px_rgba(10,13,18,0.05),_inset_0px_0px_0px_1px_rgba(10,13,18,0.18),_inset_0px_-2px_0px_rgba(10,13,18,0.05)] transition-colors',
				'hover:bg-neutral-50 active:shadow-[0px_0px_0px_1px_rgba(10,13,18,0.18),_inset_0px_0px_0px_1px_rgba(10,13,18,0.18),_inset_0px_-2px_0px_rgba(10,13,18,0.05)]',
				fullWidth && 'w-full',
				className
			)}
			{...rest}
		>
			{direction === 'left' && (
				<IconArrowLeft className='size-4' aria-hidden='true' />
			)}
			<span>{text}</span>
			{direction === 'right' && (
				<IconArrowRight className='size-4' aria-hidden='true' />
			)}
		</button>
	)
}

export default ArrowButton

